
(function () {
  if (window.__mcWishlist) return; window.__mcWishlist = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var GECKO_KEY = 't4s_wis';
  var RICH_KEY  = 'mc_wishlist';
  var LISTS_KEY = 'mc_wl_lists';
  var ACTIVE_KEY = 'mc_wl_active';

  var pop, panel, bodyEl, headingEl, busy = false;
  var mode = 'browse';
  var saveProductId = null;
  var viewListId = null;

  function el() {
    if (pop) return pop;
    pop = document.querySelector('[data-mc-wishlist]');
    if (!pop) return null;
    panel = pop.querySelector('.mc-wishlist__panel');
    bodyEl = pop.querySelector('[data-mc-wishlist-body]');
    headingEl = pop.querySelector('[data-mc-wishlist-heading]');
    return pop;
  }

  function readJSON(k, d) { try { return JSON.parse(localStorage.getItem(k) || '') || d; } catch (e) { return d; } }
  function writeJSON(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function readRich() { return readJSON(RICH_KEY, []); }
  function writeRich(a) { writeJSON(RICH_KEY, a); }
  function getLists() { return readJSON(LISTS_KEY, []); }
  function setLists(a) { writeJSON(LISTS_KEY, a); }
  function activeId() { try { return localStorage.getItem(ACTIVE_KEY) || ''; } catch (e) { return ''; } }
  function setActive(id) { try { localStorage.setItem(ACTIVE_KEY, id || ''); } catch (e) {} }
  function uid() { return 'l' + Date.now().toString(36) + Math.random().toString(16).slice(2, 6); }

  function ensureDefault() {
    var lists = getLists();
    if (!lists.length) {
      var id = uid();
      lists = [{ id: id, name: 'My Wishlist', ids: [] }];
      setLists(lists); setActive(id);
    }
    if (!activeId() || !lists.some(function (l) { return l.id === activeId(); })) setActive(lists[0].id);
    return lists;
  }
  function unionIds() {
    var set = {}, out = [];
    getLists().forEach(function (l) { (l.ids || []).forEach(function (id) { if (!set[id]) { set[id] = 1; out.push(String(id)); } }); });
    return out;
  }
  function rebuildUnion() {

    var richIds = {}; readRich().forEach(function (it) { richIds[String(it.id)] = 1; });
    var lists = getLists(); var changed = false;
    lists.forEach(function (l) {
      var before = (l.ids || []).length;
      l.ids = (l.ids || []).filter(function (id) { return richIds[String(id)]; });
      if (l.ids.length !== before) changed = true;
    });
    if (changed) setLists(lists);

    var ids = unionIds();
    try { localStorage.setItem(GECKO_KEY, ids.map(function (id) { return 'id:' + id; }).join(',')); } catch (e) {}

    writeRich(readRich().filter(function (it) { return ids.indexOf(String(it.id)) !== -1; }));

    writeCookie('mc_wishlist_ids', ids.join(','), 180);
    updateHeaderCount(ids.length);
    syncHearts(ids);
  }
  function writeCookie(name, val, days) {
    try { var d = new Date(); d.setTime(d.getTime() + (days || 180) * 864e5); document.cookie = name + '=' + encodeURIComponent(val) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax'; } catch (e) {}
  }

  function emit(type, detail) { try { document.dispatchEvent(new CustomEvent(type, { detail: detail || {} })); } catch (e) {} }
  function listName(listId) { var l = getLists().filter(function (x) { return x.id === listId; })[0]; return l ? l.name : ''; }
  function listsWith(id) { return getLists().filter(function (l) { return (l.ids || []).indexOf(String(id)) !== -1; }); }
  function evtPayload(id, listId) {
    var it = richOf(id) || {};
    return { productId: String(id), variantId: it.variantId, handle: it.handle, title: it.title,
             price: it.price, url: it.url, listId: listId || '', listName: listName(listId) };
  }
  function addToList(listId, id) {
    var lists = getLists(); id = String(id); var changed = false;
    lists.forEach(function (l) { if (l.id === listId && l.ids.indexOf(id) === -1) { l.ids.unshift(id); changed = true; } });
    setLists(lists); rebuildUnion();
    if (changed) emit('mc:wishlist:add', evtPayload(id, listId));
  }
  function removeFromList(listId, id) {
    var lists = getLists(); id = String(id);
    var payload = evtPayload(id, listId);
    lists.forEach(function (l) { if (l.id === listId) l.ids = l.ids.filter(function (x) { return x !== id; }); });
    setLists(lists); rebuildUnion();
    emit('mc:wishlist:remove', payload);
    if (unionIds().indexOf(id) === -1) deactivateHeart(id);
  }
  function removeEverywhere(id) {
    var lists = getLists(); id = String(id);
    var payload = evtPayload(id, '');
    lists.forEach(function (l) { l.ids = l.ids.filter(function (x) { return x !== id; }); });
    setLists(lists); rebuildUnion(); deactivateHeart(id);
    emit('mc:wishlist:remove', payload);
  }
  function createList(name) {
    var lists = getLists(); var id = uid();
    lists.unshift({ id: id, name: (name || 'New list').trim() || 'New list', ids: [] });
    setLists(lists); setActive(id); return id;
  }
  function deleteList(id) {
    var gone = (getLists().filter(function (l) { return l.id === id; })[0] || { ids: [] }).ids.slice();
    var lists = getLists().filter(function (l) { return l.id !== id; });
    setLists(lists);
    if (activeId() === id) setActive(lists[0] ? lists[0].id : '');
    rebuildUnion();
    var now = unionIds();
    gone.forEach(function (pid) { if (now.indexOf(String(pid)) === -1) deactivateHeart(pid); });
    notify();
  }

  function setHeart(b, on) {
    if (b.classList.contains('is--added') !== on) b.classList.toggle('is--added', on);
    if (!on && (b.classList.contains('t4s-added') || b.classList.contains('added'))) b.classList.remove('t4s-added', 'added');
    b.querySelectorAll('use').forEach(function (u) {
      var h = u.getAttribute('xlink:href') || u.getAttribute('href') || '';
      if (!/#t4s-icon-wis(-added|-remove)?$/.test(h)) return;
      var nh = on ? '#t4s-icon-wis-added' : '#t4s-icon-wis';
      if (h === nh) return;
      if (u.hasAttribute('xlink:href')) u.setAttribute('xlink:href', nh);
      if (u.hasAttribute('href')) u.setAttribute('href', nh);
      var svg = u.closest('svg'); if (svg && svg.classList.contains('t4s-svg-wis')) svg.classList.toggle('is-ic--added', on);
    });
    var s = window.T4SProductStrings || window.T4Sstrings || {};
    var t = b.querySelector('.t4s-text-pr');
    var label = on ? (s.browse_wishlist || 'Browse Wishlist') : (s.add_to_wishlist || 'Add to Wishlist');
    if (t && t.textContent !== label) t.textContent = label;
  }
  function syncHearts(ids) {
    ids = ids || unionIds();
    document.querySelectorAll('.t4s-pr-wishlist[data-id]').forEach(function (b) {
      var id = b.getAttribute('data-id');
      if (!/^\d+$/.test(id)) return;
      setHeart(b, ids.indexOf(id) !== -1);
    });
  }

  function deactivateHeart(id) {
    document.querySelectorAll('.t4s-pr-wishlist[data-id="' + id + '"]').forEach(function (b) { setHeart(b, false); });
  }

  function esc(s) { return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }
  function money(cents) {
    try { if (window.Shopify && Shopify.formatMoney && window.theme && theme.moneyFormat) return Shopify.formatMoney(cents, theme.moneyFormat); } catch (e) {}
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function sizedImg(src, px) { if (!src) return ''; if (/_(\d+)x(\d+)?\./.test(src)) return src; return src.replace(/(\.[a-z]+)(\?|$)/i, '_' + px + 'x$1$2'); }
  function handleFromHref(href) { if (!href) return ''; var m = String(href).match(/\/products\/([^/?#]+)/); return m ? m[1] : ''; }
  function geckoIds() {
    var raw = ''; try { raw = localStorage.getItem(GECKO_KEY) || ''; } catch (e) {}
    return raw ? raw.split(',').map(function (s) { return s.replace(/^id:/, '').trim(); }).filter(Boolean) : [];
  }
  function updateHeaderCount(n) {
    document.querySelectorAll('[data-count-wishlist]').forEach(function (b) { b.textContent = n; b.classList.toggle('t4s-op-0', !n); });
  }
  function richOf(id) { return readRich().filter(function (it) { return String(it.id) === String(id); })[0]; }
  function fetchProduct(handle) {
    return fetch(root + 'products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  function cacheProduct(p) {
    if (!p) return;
    var rich = readRich();
    if (rich.some(function (x) { return String(x.id) === String(p.id); })) return;
    var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0] || {};
    rich.unshift({ id: p.id, handle: p.handle, title: p.title, image: (p.featured_image || (p.images && p.images[0]) || ''),
      price: (v.price != null ? v.price : p.price), url: p.url || (root + 'products/' + p.handle), variantId: v.id, available: !!p.available });
    writeRich(rich);
  }

  function notify() { try { document.dispatchEvent(new CustomEvent('mc:wishlist:updated')); } catch (e) {} }
  function renderIfOpen() { if (pop && !pop.hidden) render(); }

  function renderSave() {
    headingEl.textContent = 'Save to list';
    var it = richOf(saveProductId);
    var lists = getLists();
    var prod = it ? (
      '<div class="mc-wishlist__saveprod">' +
        '<span class="mc-wishlist__thumb is--sm">' + (it.image ? '<img src="' + esc(sizedImg(it.image, 160)) + '" alt="">' : '') + '</span>' +
        '<div class="mc-wishlist__info"><span class="mc-wishlist__name">' + esc(it.title) + '</span><span class="mc-wishlist__price">' + money(it.price) + '</span></div>' +
      '</div>') : '';
    var rows = lists.map(function (l) {
      var added = (l.ids || []).indexOf(String(saveProductId)) !== -1;
      return '<li class="mc-wishlist__listrow' + (added ? ' is--added' : '') + '" data-list-id="' + esc(l.id) + '">' +
        '<span class="mc-wishlist__listname">' + esc(l.name) + '</span>' +
        '<button type="button" class="mc-wishlist__listtoggle" data-mc-wl-toggle>' + (added ? 'Added' : 'Add') + '</button>' +
      '</li>';
    }).join('');
    bodyEl.innerHTML =
      prod +
      '<ul class="mc-wishlist__lists">' + rows + '</ul>' +
      '<div class="mc-wishlist__create">' +
        '<p class="mc-wishlist__create-title">Create new list</p>' +
        '<div class="mc-wishlist__create-row">' +
          '<input type="text" class="mc-wishlist__create-input" data-mc-wl-newname placeholder="List name" aria-label="New list name" maxlength="40">' +
          '<button type="button" class="mc-wishlist__create-btn" data-mc-wl-create>Create &amp; add</button>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="mc-wishlist__btn mc-wishlist__btn--outline mc-wishlist__done" data-mc-wl-browse>View saved items</button>';
  }

  function renderBrowse() {
    var lists = getLists();
    var total = unionIds().length;
    headingEl.textContent = total ? ('Saved items (' + total + ')') : 'Saved items';
    if (!total && !lists.length) {
      bodyEl.innerHTML =
        '<div class="mc-wishlist__empty">' +
          '<svg viewBox="0 0 24 24" width="30" height="30" aria-hidden="true"><path d="M12 20s-7-4.6-7-10a4 4 0 0 1 7-2.3A4 4 0 0 1 19 10c0 5.4-7 10-7 10z" fill="none" stroke="currentColor" stroke-width="1.3"/></svg>' +
          '<p class="mc-wishlist__empty-text">You haven’t saved anything yet.</p>' +
          '<a class="mc-wishlist__btn mc-wishlist__btn--outline" href="' + esc(root) + 'collections/all">Start shopping</a>' +
        '</div>';
      return;
    }
    if (!lists.some(function (l) { return l.id === viewListId; })) viewListId = '';

    var tabs = '<button type="button" class="mc-wishlist__tab' + (viewListId === '' ? ' is--active' : '') + '" data-mc-wl-tab="">All (' + total + ')</button>' +
      lists.map(function (l) {
        return '<button type="button" class="mc-wishlist__tab' + (viewListId === l.id ? ' is--active' : '') + '" data-mc-wl-tab="' + esc(l.id) + '">' + esc(l.name) + ' (' + (l.ids || []).length + ')</button>';
      }).join('') +
      '<button type="button" class="mc-wishlist__tab mc-wishlist__tab--new" data-mc-wl-newlist>+ New list</button>';

    var ids;
    if (viewListId === '') ids = unionIds();
    else { var cur = lists.filter(function (l) { return l.id === viewListId; })[0]; ids = (cur && cur.ids) || []; }

    var body;
    if (!ids.length) {
      body = '<p class="mc-wishlist__listempty">No items in this list yet.</p>';
    } else {
      body = '<div class="mc-wishlist__items">' + ids.map(function (id) {
        var it = richOf(id); if (!it) return '';
        var img = sizedImg(it.image, 200);
        return '<div class="mc-wishlist__item" data-id="' + esc(it.id) + '">' +
          '<a class="mc-wishlist__thumb" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="mc-wishlist__info">' +
            '<a class="mc-wishlist__name" href="' + esc(it.url) + '">' + esc(it.title) + '</a>' +
            '<span class="mc-wishlist__price">' + money(it.price) + '</span>' +
            '<div class="mc-wishlist__actions">' +
              (it.variantId && it.available !== false
                ? '<button type="button" class="mc-wishlist__add" data-mc-wishlist-add data-vid="' + esc(it.variantId) + '">Add to bag</button>'
                : '<span class="mc-wishlist__soldout">Unavailable</span>') +
            '</div>' +
          '</div>' +
          '<button type="button" class="mc-wishlist__remove" data-mc-wishlist-remove aria-label="Remove">' +
            '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</div>';
      }).join('') + '</div>';
    }

    var listbar = '';
    if (viewListId !== '') {
      var curName = (lists.filter(function (l) { return l.id === viewListId; })[0] || {}).name || '';
      listbar = '<div class="mc-wishlist__listbar"><span class="mc-wishlist__listbar-name">' + esc(curName) + '</span>' +
        '<button type="button" class="mc-wishlist__listdelete" data-mc-wl-delete>Delete list</button></div>';
    }
    bodyEl.innerHTML = '<div class="mc-wishlist__tabs">' + tabs + '</div>' + listbar + body;
  }

  function render() { if (!el()) return; (mode === 'save') ? renderSave() : renderBrowse(); }

  function openBrowse(listId) { mode = 'browse'; if (listId != null) viewListId = listId; doOpen(); }
  function openSave(id) { mode = 'save'; saveProductId = id; doOpen(); }
  function doOpen() {
    if (!el()) return;
    render();
    pop.hidden = false;
    document.documentElement.classList.add('mc-wishlist-open');
    void pop.offsetWidth;
    pop.classList.add('is--open');
    chatFade(true);
  }
  function close() {
    if (!pop) return;
    pop.classList.remove('is--open');
    document.documentElement.classList.remove('mc-wishlist-open');
    chatFade(false);
    setTimeout(function () { if (pop && !pop.classList.contains('is--open')) pop.hidden = true; }, 340);
  }
  function chatFade(on) {
    var c = document.querySelector('shopify-chat') || document.getElementById('shopify-chat');
    if (!c) return;
    c.style.transition = 'opacity .2s ease'; c.style.opacity = on ? '0' : ''; c.style.pointerEvents = on ? 'none' : '';
  }

  function addToBag(vid, btn) {
    if (busy || !vid) return; busy = true;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] }) })
      .then(function (r) { return r.json(); }).then(function () { close(); })
      .catch(function () {}).finally(function () { busy = false; if (btn) { btn.disabled = false; btn.textContent = 'Add to bag'; } });
  }

  window.MCWishlist = {
    all: function () { var ids = unionIds(); return readRich().filter(function (it) { return ids.indexOf(String(it.id)) !== -1; }); },
    lists: function () { return getLists().map(function (l) { return { id: l.id, name: l.name, ids: (l.ids || []).slice() }; }); },
    items: function (listId) { var l = getLists().filter(function (x) { return x.id === listId; })[0]; var ids = l ? l.ids : []; return readRich().filter(function (it) { return ids.indexOf(String(it.id)) !== -1; }); },
    count: function () { return unionIds().length; },
    ids: function () { return unionIds(); },
    has: function (id) { return unionIds().indexOf(String(id)) !== -1; },
    add: function (item, listId) {
      if (!item || item.id == null) return;
      ensureDefault();
      var rich = readRich();
      if (!rich.some(function (it) { return String(it.id) === String(item.id); })) { rich.unshift(item); writeRich(rich); }
      addToList(listId || activeId(), item.id);
      renderIfOpen(); notify();
    },
    remove: function (id) { removeEverywhere(id); renderIfOpen(); notify(); },
    createList: function (name) { var id = createList(name); notify(); return id; },
    open: function () { openBrowse(viewListId); },
    sync: function () { syncHearts(); }
  };

  function closeVendorDrawers() {
    if (document.querySelector('.mc-drawer-open') || document.querySelector('.t4s-drawer[aria-hidden="false"]')) {
      var overlay = document.querySelector('.t4s-close-overlay');
      if (overlay) overlay.click();
    }
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[data-link-wishlist], a[href*="view=wishlist"]');
    if (link) {
      e.preventDefault(); e.stopPropagation();
      closeVendorDrawers();
      setTimeout(function () { openBrowse(viewListId); }, 80);
    }
  }, true);

  document.addEventListener('click', function (e) {
    var wl = e.target.closest('.t4s-pr-wishlist, [data-action-wishlist]');
    if (!wl) return;
    var id = wl.getAttribute('data-id') || '';
    var handle = handleFromHref(wl.getAttribute('href') || wl.dataset.href || '') || (wl.dataset.handle || '');
    var wasSaved = id && geckoIds().indexOf(String(id)) !== -1;

    if (wasSaved) {
      e.preventDefault(); e.stopImmediatePropagation();
      ensureDefault(); openBrowse(viewListId);
      return;
    }

    setTimeout(function () {
      ensureDefault();
      var pid = id;
      function afterCache() {
        if (!pid) { var g = geckoIds(); pid = g[0]; }
        if (!pid) { rebuildUnion(); return; }
        if (geckoIds().indexOf(String(pid)) === -1) { rebuildUnion(); return; }
        addToList(activeId(), pid);
        openSave(pid);
      }
      if (handle && !richOf(id)) { fetchProduct(handle).then(function (p) { if (p) { pid = p.id; cacheProduct(p); } afterCache(); }); }
      else { afterCache(); }
    }, 120);
  }, true);

  document.addEventListener('click', function (e) {
    if (!pop || pop.hidden) return;
    if (e.target.closest('[data-mc-wishlist-close]')) { close(); return; }

    var toggle = e.target.closest('[data-mc-wl-toggle]');
    if (toggle) {
      var row = toggle.closest('[data-list-id]'); var lid = row.getAttribute('data-list-id');
      if ((getLists().filter(function (l) { return l.id === lid; })[0] || { ids: [] }).ids.indexOf(String(saveProductId)) !== -1) removeFromList(lid, saveProductId);
      else addToList(lid, saveProductId);
      renderSave(); notify(); return;
    }
    if (e.target.closest('[data-mc-wl-create]')) {
      var inp = pop.querySelector('[data-mc-wl-newname]'); var nm = inp ? inp.value : '';
      var lid2 = createList(nm); addToList(lid2, saveProductId); renderSave(); notify(); return;
    }
    if (e.target.closest('[data-mc-wl-browse]')) { openBrowse(''); return; }

    var tab = e.target.closest('[data-mc-wl-tab]');
    if (tab) { viewListId = tab.getAttribute('data-mc-wl-tab'); renderBrowse(); return; }
    if (e.target.closest('[data-mc-wl-newlist]')) {
      var name = window.prompt('Name your list'); if (name && name.trim()) { viewListId = createList(name); renderBrowse(); notify(); } return;
    }
    if (e.target.closest('[data-mc-wl-delete]') && viewListId !== '') {
      if (window.confirm('Delete this list? Items only in this list will be removed from your saved items.')) {
        deleteList(viewListId); viewListId = ''; renderBrowse();
      }
      return;
    }
    var item = e.target.closest('.mc-wishlist__item');
    if (e.target.closest('[data-mc-wishlist-remove]') && item) {
      var rid = item.getAttribute('data-id');
      if (viewListId === '') removeEverywhere(rid); else removeFromList(viewListId, rid);
      renderBrowse(); notify(); return;
    }
    var add = e.target.closest('[data-mc-wishlist-add]');
    if (add) { addToBag(add.getAttribute('data-vid'), add); return; }
    if (!e.target.closest('.mc-wishlist__panel')) close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop && !pop.hidden) close(); });

  window.addEventListener('storage', function (e) {
    if (e.key !== LISTS_KEY) return;
    var ids = unionIds();
    updateHeaderCount(ids.length);
    syncHearts(ids);
    renderIfOpen();
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { rebuildUnion(); renderIfOpen(); } });
  document.addEventListener('mc:wishlist:updated', function () { syncHearts(); });

  function redirectIfWishlistPage() {
    if (location.pathname.indexOf('/search') === 0 && /[?&]view=wishlist\b/.test(location.search)) {
      location.replace(root + '#saved');
      return true;
    }
    return false;
  }
  function openFromHash() {
    if (location.hash !== '#saved') return;
    try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
    var tries = 0; var iv = setInterval(function () { if (el()) { clearInterval(iv); openBrowse(''); } else if (++tries > 30) clearInterval(iv); }, 120);
  }

  function init() {
    if (redirectIfWishlistPage()) return;
    rebuildUnion();
    openFromHash();
  }

  if (!redirectIfWishlistPage()) {
    if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
    window.addEventListener('hashchange', openFromHash);
  }
})();
